import React from "react";
import "./MultiStepProgressBar.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { RightIcon } from "../../../assets/icon";
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  root: {
    height: 'auto',
    width: '100%',
    paddingTop: '1.250rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: '1.250rem'
  },
  progressBar: {
    height: '40px',
    width: 'auto'
  },
  stepText: {
    backgroundColor: "#FF4F21 !important",
    color: "#ffffff !important",
    width: "150px",
    height: "62px",
    border: "none",
    borderRadius: "40px",
    cursor: 'auto',
    fontSize: '32px',
  },
  checkIcon:{
    width: '25px',
    height: '25px'
  },
  "@media (max-width: 800px)": {
    root: {
      rowGap: '20px',
      paddingTop: '0px'
    },
    progressBar: {
      height: '24px',
      width: 'auto',
    },
    stepText: {
      width: "90px",
      height: "40px",
      fontSize: '18px',
    },
    checkIcon:{
      width: '16px',
      height: '16px'
    },
  }
})

const MultiStepProgressBar = ({ step, page }) => {
  const classes = useStyles()

  var stepPercentage = 0;
  if (page === "pageone") {
    stepPercentage = 16;
  } else if (page === "pagetwo") {
    stepPercentage = 29;
  } else if (page === "pagethree") {
    stepPercentage = 62;
  } else if (page === "pagefour") {
    stepPercentage = 96;
  } else {
    stepPercentage = 0;
  }

  return (
    <div className={classes.root}>
      <ProgressBar percent={stepPercentage}>
        <Step>
          {({ accomplished }) => (
            <div
              className={`indexedStep ${accomplished ? "accomplished" : null}`}
            >
              
              {step !== "STEP 1" &&  <RightIcon className={classes.checkIcon} />}
            </div>
          )}
        </Step>
        <Step>
          {({ accomplished }) => (
            <div
              className={`indexedStep ${accomplished ? "accomplished" : null}`}
            >
  
            {step === "STEP 2" || "STEP 3" &&  <RightIcon className={classes.checkIcon} /> }

            </div>
          )}
        </Step>
        <Step>
          {({ accomplished }) => (
            <div
              className={`indexedStep ${accomplished ? "accomplished" : null}`}
            >
            {step === "STEP 4" &&  <RightIcon className={classes.checkIcon} />}
            </div>
          )}
        </Step>
        <Step>
          {({ accomplished }) => (
            <div
              className={`indexedStep ${accomplished ? "accomplished" : null}`}
            >
            {step === "STEP 5" &&  <RightIcon className={classes.checkIcon} /> }
            </div>
          )}
        </Step>
        
        </ProgressBar>
    </div>
  );
};

export default MultiStepProgressBar;